import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ReathletikGiveAccessRequestDto} from '../../dtos/reathletikGiveAccessRequest.dto';
import {ClinikoGiveAccessRequestDto} from '../../dtos/clinikoGiveAccessRequest.dto';

@Injectable({
    providedIn: 'root'
})
export class ClinikoAdminService {

    constructor(private _httpClient: HttpClient) {}

    public giveAccess(giveAccessDto: ClinikoGiveAccessRequestDto): Observable<void> {
        return this._httpClient.post<any>(environment.apiUrl + 'api/integration/cliniko/admin/v1/giveAccess', giveAccessDto);
    }
}
